
import './CopTable.scss';

import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid'

export type AgreementColumnTitles = {
  agreementNumber?: string
  validityFrom?: string
  validityTo?: string
  status?: string
  legalEntityName?: string
  view?: string
}

const getDetailUrl = (id: string, viewPageUrl?: string) => {
  if (viewPageUrl) return `${viewPageUrl}/${id}`
  const basePath = window.location.pathname.replace(/\/[^/]*$/, '')
  return `${window.location.origin}${basePath}/agreement-details/${id}`
}

const AgreementLink = ({ value, id, viewPageUrl }: { value: string; id: string; viewPageUrl?: string }) => (
  <a href={getDetailUrl(id, viewPageUrl)} className="cop-agreement-link">
    {value}
  </a>
);

const StatusCell = ({ value }: { value: string }) => {
  const isActive = value === 'Active';
  return (
    <span className="cop-status-cell">
      <span className={`cop-status-dot cop-status-dot--${isActive ? 'active' : 'inactive'}`} />
      <span>{value}</span>
    </span>
  );
};

const ViewButton = ({ id, viewPageUrl, viewLabel = 'View' }: { id: string; viewPageUrl?: string; viewLabel?: string }) => (
  <button
    className="cop-view-button"
    onClick={() => { window.location.href = getDetailUrl(id, viewPageUrl); }}
  >
    {viewLabel}
  </button>
);

export function getAgreementColumns(
  columnTitles: AgreementColumnTitles = {},
  viewPageUrl?: string,
  canViewAgreementDetails?: boolean,
): GridColDef[] {
  return  [
    {
      field: 'number',
      headerName: columnTitles.agreementNumber ?? 'Agreement Number',
      flex: 1,
      minWidth: 180,
      filterable:true,
      renderCell: (params: GridRenderCellParams) => <AgreementLink value={params.value} id={String(params.row.id)} viewPageUrl={viewPageUrl} />,
    },
    {
      field: 'validFrom',
      headerName: columnTitles.validityFrom ?? 'Validity From',
      flex: 0.8,
      minWidth: 130,
      filterable:true,
      renderCell: (params: GridRenderCellParams) => {
        if (!params.value) return '—';
        return new Date(params.value).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
      },
    },
    {
      field: 'validTo',
      headerName: columnTitles.validityTo ?? 'Validity To',
      flex: 0.8,
      minWidth: 130,
      filterable:true,
      renderCell: (params: GridRenderCellParams) => {
        if (!params.value) return '—';
        return new Date(params.value).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
      },
    },
    {
      field: 'status',
      headerName: columnTitles.status ?? 'Status',
      flex: 0.7,
      minWidth: 120,
      filterable:true,
     renderCell: (params: GridRenderCellParams) => <StatusCell value={params.value} />,
    },
    {
      field: 'legalEntityName',
      headerName: columnTitles.legalEntityName ?? 'Legal Entity Name',
      flex: 2,
      minWidth: 260,
      filterable:true,
    },
    ...(canViewAgreementDetails ? [{
      field: 'actions',
      headerName: columnTitles.view ?? 'View',
      flex: 0.5,
      minWidth: 130,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params: GridRenderCellParams) => <ViewButton id={String(params.row.id)} viewPageUrl={viewPageUrl} viewLabel={columnTitles.view} />,
    }] : []),
  ]
}
